"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.teamUrl = exports.getStructuredData = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _string = require("@raywhite/helpers-utils/lib/helpers/string");
var _sanitization = require("@raywhite/helpers-utils/lib/helpers/sanitization");
var _structuredData = require("@raywhite/helpers-utils/lib/helpers/structuredData");
var teamUrl = (id, name) => {
  var _context;
  return (0, _concat.default)(_context = "/teams/".concat((0, _string.toSlug)(name), "/")).call(_context, id);
};
exports.teamUrl = teamUrl;
var getStructuredData = (data, baseUrl) => {
  var _context2;
  var {
    description,
    email,
    facebook,
    fax,
    fullName,
    googlePlus,
    id,
    imageTeam,
    instagram,
    linkedin,
    pinterest,
    primaryPhone,
    twitter,
    youtube
  } = data;
  return (0, _structuredData.realEstateAgent)({
    name: fullName,
    description: (0, _sanitization.plainText)(description),
    url: baseUrl && (0, _concat.default)(_context2 = "".concat(baseUrl)).call(_context2, teamUrl(id, fullName)),
    faxNumber: fax,
    telephone: primaryPhone,
    email,
    image: imageTeam && "".concat(imageTeam, "?maxwidth=1280"),
    sameAs: [facebook, twitter, googlePlus, youtube, linkedin, pinterest, instagram]
  });
};
exports.getStructuredData = getStructuredData;